import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const AgreeModal = styled.div`
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  background-color: #fff;
  max-height: calc(-50px + 100vh);
  height: 100%;
  border-radius: 20px 20px 0 0;
  overflow: hidden;
  overflow-y: auto;

  .content {
    padding: 0 20px;

    .agree-ctns {
      table {
        border-top: 1px solid #000;
        border-bottom: 1px solid #000;
        font-size: 12px;
        line-height: 130%;
        width: 100%;

        th {
          border-bottom: 1px solid #eee;
          width: 33.3333333%;
          padding: 12px;
          background: #f6f6f6;
          font-weight: 400;
        }

        td {
          padding: 12px;
          text-align: center;
          color: #555;
        }
      }

      .unorder-list {
        margin-top: 16px;

        li {
          position: relative;
          margin-top: 10px;
          font-size: 11px;
          line-height: 145%;
          padding-left: 10px;
          color: #999;

          em {
            color: #000;
            text-decoration-line: underline;
          }

          &:first-child {
            margin-top: 0;
          }

          &:before {
            content: '';
            display: inline-block;
            width: 2px;
            height: 2px;
            background: #999;
            border-radius: 50%;
            position: absolute;
            left: 0;
            top: 6px;
          }
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    border-radius: ${mixin.pxToVw('20 20 0 0')};

    .content {
      padding: ${mixin.pxToVw('0 20')};

      .agree-ctns {
        table {
          font-size: ${mixin.pxToVw('12')};

          th {
            padding: ${mixin.pxToVw('12')};
          }

          td {
            padding: ${mixin.pxToVw('12')};
          }
        }

        .unorder-list {
          margin-top: ${mixin.pxToVw('16')};

          li {
            margin-top: ${mixin.pxToVw('10')};
            font-size: ${mixin.pxToVw('11')};
            padding-left: ${mixin.pxToVw('10')};

            &:before {
              width: ${mixin.pxToVw('2')};
              height: ${mixin.pxToVw('2')};
              top: ${mixin.pxToVw('6')};
            }
          }
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    max-height: none;
    height: auto;
    border-radius: 0;
    max-width: 560px;

    .modal-title {
      padding: 30px 52px 24px 32px;
      margin-bottom: 0;

      .title {
        text-align: left;
        font-size: 24px;
      }
    }

    .modal-close-btn {
      position: absolute;
      top: 12px;
      right: 12px;
    }

    .content {
      padding: 0 32px 28px 32px;

      .agree-ctns {
        table {
          font-size: 15px;

          th {
            padding: 14px 12px;
          }

          td {
            padding: 14px 12px;
          }
        }

        .unorder-list {
          margin-top: 18px;

          li {
            font-size: 13px;
            line-height: 130%;

            &:first-child {
              font-size: 15px;
            }

            &:before {
              width: 3px;
              height: 3px;
              top: 7px;
            }
          }
        }
      }
    }

    .modal-group-btn {
      border-top: 1px solid #eee;
      padding: 24px 87px;
    }
  }
`;
